import { generatePath } from 'react-router-dom';

import {
  NotificationActions,
  NotificationContent,
  NotificationTip,
  NotificationTipText,
} from 'approot/shared/notifications/notification-tip.style';
import { SecondaryButtonLink } from 'approot/shared/styles/buttons/secondary-button.style';
import IconExpand from 'approot/shared/icons/icon-expand';
import { PRIVATE_EDIT_STIMULUS } from 'global/private-routes.constants';
import { ASSESSMENT, LESSON_ACTIVITIES, LESSON } from 'global/constants';
import { useGetInteractiveLessonParams } from 'approot/activity-builder/activity-builder.hooks';

type Props = {
  stimulusId: number;
  componentId: string;
  sectionId: string;
  contentId: number;
};

const StimulusUsageMessage = ({
  stimulusId,
  componentId,
  sectionId,
  contentId,
}: Props) => {
  const { slug, contentType } = useGetInteractiveLessonParams();
  const lessonType = contentType === LESSON_ACTIVITIES ? LESSON : ASSESSMENT;

  return (
    <NotificationTip $marginBottom={24}>
      <NotificationContent>
        <NotificationTipText>
          Any changes you make will also be reflected across other lessons using
          this stimulus.
        </NotificationTipText>
        <NotificationActions>
          <SecondaryButtonLink
            data-selector="btn-edit-stimulus"
            $isSmall
            to={
              generatePath(PRIVATE_EDIT_STIMULUS, {
                id: `${stimulusId}`,
              }) +
              `?routeSlug=${slug}&lessonType=${lessonType}&contentId=${contentId}&sectionId=${sectionId}&componentId=${componentId}`
            }
          >
            Edit Stimulus Details <IconExpand width={16} height={16} />
          </SecondaryButtonLink>
        </NotificationActions>
      </NotificationContent>
    </NotificationTip>
  );
};

export default StimulusUsageMessage;
